import { Routes } from "@angular/router";
import { WorkflowCspOneCancelPhonenumberComponent } from "./workflow-csp-one-cancel-phonenumber.component";

export const workflowCspOneCancelPhonenumberRouting: Routes = [
    { path: 'csp/cancel-phonenumber/:aid/:bid', component: WorkflowCspOneCancelPhonenumberComponent, children: [
        { path: 'confirm', component: WorkflowCspOneCancelPhonenumberComponent, data: { step: 'confirm' } },
        { path: 'address', component: WorkflowCspOneCancelPhonenumberComponent, data: { step: 'address' } },
        { path: 'payment', component: WorkflowCspOneCancelPhonenumberComponent, data: { step: 'payment' } },
        { path: 'checkout-summary', component: WorkflowCspOneCancelPhonenumberComponent, data: { step: 'checkout-summary' } },
        { path: 'complete', component: WorkflowCspOneCancelPhonenumberComponent, data: { step: 'complete' } },
        { path: '', redirectTo: 'confirm', pathMatch: 'full' },
    ]},
]